// @flow
import loadable from '@loadable/component';
import renderComponent from 'components/editable/renderComponent';
import StoryblokEntry from './StoryblokEntry';
import * as componentKeys from '../componentKeys';

const Page = {
  asyncComponentName: 'editable/Page',
  AsyncComponent: loadable(() => import('../components/editable/Page'), {
    ssr: true
  })
};
const StaticContent = {
  asyncComponentName: 'editable/StaticContent',
  AsyncComponent: loadable(
    () => import('../components/editable/StaticContent'),
    { ssr: true }
  )
};
const AggregateNewsPage = {
  asyncComponentName: 'editable/blog/AggregateNews',
  AsyncComponent: loadable(
    () => import('../components/editable/blog/AggregateNews'),
    { ssr: true }
  )
};
const BlogAggregatePage = {
  asyncComponentName: 'editable/blog/AggregatePage',
  AsyncComponent: loadable(
    () => import('../components/editable/blog/AggregatePage'),
    { ssr: true }
  )
};
const BlogPost = {
  asyncComponentName: 'editable/blog/Post',
  AsyncComponent: loadable(() => import('../components/editable/blog/Post'), {
    ssr: true
  })
};

export default function GenericTemplate(props: *) {
  return (
    <StoryblokEntry {...props}>
      {(story) =>
        story &&
        story.content &&
        renderComponent(
          story.content,
          {
            customPath: 'templates/Generic.jsx',
            key: story.content._uid
          },
          {
            [componentKeys.PAGE]: Page,
            [componentKeys.PORTAL_PAGE]: Page,
            [componentKeys.STATIC_CONTENT]: StaticContent,
            [componentKeys.AGGREGATE_NEWS_PAGE]: AggregateNewsPage,
            [componentKeys.BLOG_AGGREGATE_PAGE]: BlogAggregatePage,
            [componentKeys.BLOG_POST]: BlogPost
          }
        )
      }
    </StoryblokEntry>
  );
}
